import _defineProperty from "C:\\Users\\Administrator\\Desktop\\KaporgLatestC\\KAPorg-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import { unit } from '@ant-design/cssinjs';
var genDraggerStyle = function genDraggerStyle(token) {
  var componentCls = token.componentCls,
    iconCls = token.iconCls;
  return _defineProperty({}, "".concat(componentCls, "-wrapper"), _defineProperty({}, "".concat(componentCls, "-drag"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    position: 'relative',
    width: '100%',
    height: '100%',
    textAlign: 'center',
    background: token.colorFillAlter,
    border: "".concat(unit(token.lineWidth), " dashed ").concat(token.colorBorder),
    borderRadius: token.borderRadiusLG,
    cursor: 'pointer',
    transition: "border-color ".concat(token.motionDurationSlow)
  }, componentCls, {
    padding: token.padding
  }), "".concat(componentCls, "-btn"), {
    display: 'table',
    width: '100%',
    height: '100%',
    outline: 'none',
    borderRadius: token.borderRadiusLG,
    '&:focus-visible': {
      outline: "".concat(unit(token.lineWidthFocus), " solid ").concat(token.colorPrimaryBorder)
    }
  }), "".concat(componentCls, "-drag-container"), {
    display: 'table-cell',
    verticalAlign: 'middle'
  }), "\n          &:not(".concat(componentCls, "-disabled):hover,\n          &-hover:not(").concat(componentCls, "-disabled)\n        "), {
    borderColor: token.colorPrimaryHover
  }), "p".concat(componentCls, "-drag-icon"), _defineProperty({
    marginBottom: token.margin
  }, iconCls, {
    color: token.colorPrimary,
    fontSize: token.uploadThumbnailSize
  })), "p".concat(componentCls, "-text"), {
    margin: "0 0 ".concat(unit(token.marginXXS)),
    color: token.colorTextHeading,
    fontSize: token.fontSizeLG
  }), "p".concat(componentCls, "-hint"), {
    color: token.colorTextDescription,
    fontSize: token.fontSize
  }), "&".concat(componentCls, "-disabled"), _defineProperty({}, "p".concat(componentCls, "-drag-icon ").concat(iconCls, ",\n            p").concat(componentCls, "-text,\n            p").concat(componentCls, "-hint\n          "), {
    color: token.colorTextDisabled
  }))));
};
export default genDraggerStyle;